import {CAMERA_MODE} from "./CameraRenderer";
import {GameManager} from "./GameManager";
import {SandBug} from "../game/SandBug";
import {FitUtil} from "./FitUtil";
import { getAnalytics, logEvent } from "firebase/analytics";
import {ContentsSetting, GLOBAL_SETTING_KEY} from "./ContentsSetting";
import Vue from "vue";

export const CommonMixin = {
  head() {
    return FitUtil.generateHeader(
      this.title,
      this.desc,
      this.ogImg
    )
  },
  data() {
    const path = location.pathname.split('/')
    const contentsId = path[path.length - 1]
    const globalSetting = new ContentsSetting(GLOBAL_SETTING_KEY)
    const contentsSetting = new ContentsSetting(contentsId)
    return {
      globalSetting,
      contentsSetting,
      displayValue: {},

      hideMenu: false,
      navigations: [],
      defaultCameraMode: CAMERA_MODE.FIGURE,
      mute: false,
      deviceState: null,
      cameraMode: null,
      ci: null,
      manager: null,
      score: null,
      debugMeg: '',
      CAMERA_MODE,
      menu: {
        installMobile: false,
        audio: false,
        analytics: true,
        videoMode: true,
      },
      settings: [],
      steps:[],
    }
  },
  computed: {
    title() {
      return 'title'
    },
    desc() {
      return 'desc'
    },
    ogImg() {
      return 'https://storage.googleapis.com/wcam-27caf.appspot.com/public/ogp/screen_1200_628.png'
    },
    currentCameraMode() {
      return this.manager ? this.manager.cameraRenderer.cameraMode : null
    },
    canShowHeaderMenu() {
      return !this.hideMenu && this.deviceState === 'ready'
    },
    canShowFooterMenu() {
      return !this.hideMenu
    },
    canShowSideMenu() {
      return !this.hideMenu && this.deviceState === 'ready'
    },
    canShowCommonDisplay() {
      return !this.hideMenu && this.deviceState === 'ready'
    }
  },
  created: function () {
  },
  mounted() {
    this.checkAndStart()
  },
  beforeDestroy() {
    clearInterval(this.ci)
  },
  methods: {
    defaultHeaderMenu() {
      return {
        installMobile: false,
        audio: true,
        analytics: true,
        videoMode: true,
      }
    },
    defaultSideMenu() {
      return {
        help: true,
        settings: true,
        'capture-video': false,
      }
    },
    defaultFooterMenu() {
      return {
        home: true,
        analytics: true,
      }
    },
    createContents() {
      console.error('createContents is not implemented')
      return null;
    },
    getOptions() {
      const options = {}
      if (FitUtil.isSafari() || FitUtil.isiOS()) {
        options.pose = {
          modelType: 'lite',
          backend: 'tfjs-webgl',
        }
      } else {
        options.pose = {
          modelType: 'full',
          backend: 'mediapipe-gpu',
        }
      }
      return options
    },
    async checkCamera() {
      // return "prompt"

      if (FitUtil.isFirefox() || FitUtil.isSafari() || FitUtil.isiOS() || !navigator.permissions || !navigator.permissions.query) {
        return "prompt"
      }
      const permissionObj = await navigator.permissions.query({name: 'camera'})
      return permissionObj.state
    },
    onButtonClicked(type) {
      switch (type) {
        case 'help':
          this.$refs['modal'].$emit('open-modal')
          break
        case 'capture-video':
          // const params = new URLSearchParams(location.search)
          // params.append('save', 1)
          // location.href = location.href + (location.search ? '':'?') + params.toString()
          if (!this.recording) {
            if(this.manager)this.manager.startCapture()
            this.recording = true
          } else {
            this.manager.stopCapture()
            this.recording = false

          }
          break

        case 'volume':
          this.onMuteChange(!this.mute)
          break
        case 'settings':
          if (!this.$refs['settings']) {
            console.warn('no setting')
            return
          }
          this.$refs['settings'].$emit('open-modal')
          break

        case 'tweet':
          const s = `${this.title} at WEB-FIT`;
          const url = "http://twitter.com/share?url=" + escape(document.location.href) + "&text=" + s + "&hashtags=WEBFIT";
          window.open(url,"_blank","width=600,height=300");
          break

        default:
          console.log(`${type} clicked`)
      }
    },
    onCameraChange(after) {
      if (!this.manager || !this.manager.cameraRenderer) {
        console.warn('cameraRenderer not initialized')
        return
      }
      this.manager.cameraRenderer.cameraMode = after
      this.contentsSetting.overWriteAndSave('camera-mode', after)
    },
    onPictoBgChange(after) {
      if (!this.manager || !this.manager.cameraRenderer) {
        console.warn('cameraRenderer not initialized')
        return
      }
      this.manager.cameraRenderer.pictoBgType = after
      this.globalSetting.overWriteAndSave('picto-bg', after)
    },
    onMuteChange(after) {
      window.mute = after
      this.mute = window.mute
      this.globalSetting.overWriteAndSave('mute', after)
    },
    onSettingChange(key, value, asInit) {
      if (!this.manager || !this.manager.game) {
        console.warn('contents not initialized')
        return
      }
      Vue.set(this.displayValue, key, value)

      if (key === 'picto-bg') {
        this.onPictoBgChange(value)
        return
      }
      if (key === 'mute') {
        this.onMuteChange(value)
        return
      }
      if (key === 'hide-menu') {
        this.hideMenu = value
        return
      }

      const tmp = this.settings
      this.settings.find(s => s.key === key).default = value
      // Vue.set(this.settings, key, )

      // this.displayValue[key] = value
      this.manager.game.changeSettings(key, value)
      if (!asInit) {
        this.contentsSetting.overWriteAndSave(key, value)
      }
    },
    async checkAndStart() {
      const cameraState = await this.checkCamera()
      switch (cameraState) {
        case "prompt":
          this.deviceState = 'waitCamera'
          break
        case "denied":
          this.deviceState = 'denied'
          break
        case "granted":
          this.start()
          break
        default:
          console.error(`unknown: ${cameraState}`)
          break
      }
    },
    async start() {
      const params = new URLSearchParams(location.search)
      this.deviceState = 'ready'
      this.manager = new GameManager(this.createContents(), this.getOptions())
      this.manager.cameraRenderer.cameraMode = this.contentsSetting.getValue('camera-mode', this.defaultCameraMode)

      const saved = this.contentsSetting.getAll()
      this.settings.forEach(setting => {
        const key = setting.key
        if (saved[key]) {
          this.settings.find(s => s.key === key).default = saved[key]
          setting.default = saved[key]
        }
        this.onSettingChange(key, setting.default, true)
      })

      // const globalSettings = ['picto-bg', 'mute']
      const globalSettings = [
        { key: 'picto-bg', default : 'grid' },
        { key: 'mute', default : false },
      ]
      globalSettings.forEach(setting => {
        const val = this.globalSetting.getValue(setting.key, setting.default)
        this.onSettingChange(setting.key, val, true)
      })

      // if (params.has('save')) {
      //   this.manager.startCapture()
      // }

      const analytics = getAnalytics()
      logEvent(analytics, 'contents_started')

      try {
        await this.manager.setUp()
      } catch (e) {
        if (e.toString().indexOf('Permission denied') !== -1) {
          this.deviceState = 'denied'
        }
      }
      setTimeout(async () => {
        if (!this.manager.camera.video.width) {
          this.deviceState = 'denied'
        }
      },3000)

      await this.mainLoop()

    },
    async mainLoop() {
      await this.manager.mainLoop()
      this.setScores()
      this.ci = setTimeout(() => {
        this.mainLoop()
      }, 10)
    },
    setScores() {
      this.score = this.manager.game.score;
      this.debugMeg = this.manager.game.debug;
      this.navigations = this.manager.game.navigations
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/CommonMixin.js